import LoggerConsoleConnector from "./LoggerConsoleConnector";
import LoggerNullConnector from "./LoggerNullConnector";

class Logger
{

    LOG_LEVEL_TO_INT = {
        none: 0,
        emergency: 1,
        alert: 2,
        critical: 3,
        error: 4,
        warning: 5,
        notice: 6,
        info: 7,
        debug: 8
    };

    /**
     * @param {Timer} timer
     * @param name
     * @param options
     */
    constructor(timer, name, options) {
        this._timer = timer;
        this._name = name;
        this._options = options;
        this._target = null;
        this._logLevel = this._logLevelToInt(options.logLevel);
    }

    _createTarget()
    {
        if (this._options.target === 'console') {
            return new LoggerConsoleConnector(this._timer);
        }
        return new LoggerNullConnector();
    }

    _getTarget()
    {
        if (!this._target) {
            this._target = this._createTarget();
        }
        return this._target;
    }

    _logLevelToInt(strLogLevel)
    {
        if (typeof strLogLevel !== 'string') {
            throw new Error('strLogLevel must be a string');
        }
        if (!(strLogLevel in this.LOG_LEVEL_TO_INT)) {
            throw new Error('Unknown log level ' + strLogLevel);
        }
        return this.LOG_LEVEL_TO_INT[strLogLevel];
    }

    log(level, message, context)
    {
        let logLevel = this._logLevelToInt(level);
        if (logLevel > 0 && logLevel <= this._logLevel) {
            this._getTarget().log(this._name, level, message, context);
        }
    }

    emergency(message, context)
    {
        this.log('emergency', message, context);
    }

    alert(message, context)
    {
        this.log('alert', message, context);
    }

    critical(message, context)
    {
        this.log('critical', message, context);
    }

    error(message, context)
    {
        this.log('error', message, context);
    }

    warning(message, context)
    {
        this.log('warning', message, context);
    }

    notice(message, context)
    {
        this.log('notice', message, context);
    }

    info(message, context)
    {
        this.log('info', message, context);
    }

    debug(message, context)
    {
        this.log('debug', message, context);
    }

}

export default Logger;